// Replaces the old build-time VITE_ENABLED_MODULES mechanism. SupportPortalServlet
// already injects window.__PACKAGES__ into every served index.html (same mechanism
// as window.__BASE_PATH__) - which packages are active for this deployment's servlet
// (WCMS_WebServletPackage) is already known synchronously, no fetch needed. Dynamically
// imports each active package's compiled entry module and collects their
// routes/sidebarGroups into the same shape App's `extensions` prop already expects.
export async function loadExtensions() {
  const result = { routes: [], sidebarGroups: [], slots: {} };

  for (const pkg of window.__PACKAGES__ ?? []) {
    try {
      // entryUrl is the suffix after this app's own mount (e.g. "/extensions/afspafts/entry.js") -
      // SupportPortalServlet resolves it against its classpath resource folder internally, but the
      // browser needs the real served path, which is relative to wherever this app is actually mounted.
      const url = (window.__BASE_PATH__ || '') + pkg.entryUrl;
      const mod = await import(/* @vite-ignore */ url);
      const ext = mod.default;
      if (ext?.routes) result.routes.push(...ext.routes);
      if (ext?.sidebarGroups) result.sidebarGroups.push(...ext.sidebarGroups);
      // Named extension points (see lib/ExtensionSlotsContext.jsx) - later-loaded
      // extensions win on a name collision, same as sidebarGroups/routes just append.
      if (ext?.slots) Object.assign(result.slots, ext.slots);
    } catch (e) {
      console.error(`Failed to load extension "${pkg.key}":`, e);
    }
  }

  return result;
}
